import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, computed } from 'vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { useRouter } from 'vue-router/composables';
import { ModuleName } from '@/types/module-type';
import { MerchantDpList } from '@/types/merchant';
import HotMerchantSkeleton from '@/components/skeleton/travel-tool-skeleton.vue';
import { useConfigStore, useDpStore } from '@/store';
import { JAPAN_DUAL_COLUMN_LEFT_INDEX, JAPAN_DUAL_COLUMN_RIGHT_INDEX } from '@/config/module-config/japan';


export default /*#__PURE__*/_defineComponent({
  __name: 'hot-merchant',
  props: {
    moduleName: null
  },
  emits: ['onHideModule'],
  setup(__props: any, { emit }) {

const props = __props as { moduleName: ModuleName }




const router = useRouter();
const { getConfig } = useConfigStore();
const dpStore = useDpStore();

const isReady = ref(false);
const hotMerchantDpList = ref<MerchantDpList[]>([]);
function isValidHotMerchant(item: MerchantDpList) {
  return item.merchantList?.length > 0 && item.merchantList.some(m => m.title);
}

const showHotMerchantDpList = computed(() => hotMerchantDpList.value
  .filter((_, index) => index !== JAPAN_DUAL_COLUMN_LEFT_INDEX && index !== JAPAN_DUAL_COLUMN_RIGHT_INDEX)
  .filter(isValidHotMerchant));

function goToMerchantDetail(contentPosition: string) {
  router.push({ name: 'merchantDetail', query: { id: contentPosition } });
}

onBeforeMount(async () => {
  const { isMerchantInited, merchantDpList } = dpStore;
  if (!isMerchantInited) {
    const result = await getConfig(props.moduleName);
    hotMerchantDpList.value = result?.merchantDpList || [];
  } else {
    hotMerchantDpList.value = merchantDpList || [];
  }

  isReady.value = true;

  if (!showHotMerchantDpList.value.length) {
    emit('onHideModule', props.moduleName);
  }
});

return { __sfc: true,props, emit, router, getConfig, dpStore, isReady, hotMerchantDpList, isValidHotMerchant, showHotMerchantDpList, goToMerchantDetail, ThemeCard, HotMerchantSkeleton }
}

})